module.exports = __webpack_public_path__ + "img/toothpaste-product-sensitivity.2b219088.jpg";